/**
 * bula_ref cookie helpers — Phase B persistence.
 *
 * When a co-branded share link lands on the SPA (e.g. /properties/123?ref=ab12cd),
 * we persist the ref in a 30-day cookie so that even if the user browses around
 * before signing up, the registration form still auto-prefills referral_code.
 */

const COOKIE_NAME = "bula_ref";
const TTL_DAYS = 30;
// Backend referral codes are 8 lowercase hex chars (uuid4().hex[:8]).
const VALID_RE = /^[a-f0-9]{8}$/;

function isValid(code) {
    return typeof code === "string" && VALID_RE.test(code);
}

export function captureRefFromUrl() {
    if (typeof window === "undefined") return null;
    try {
        const params = new URLSearchParams(window.location.search);
        const raw = (params.get("ref") || "").trim().toLowerCase();
        if (!isValid(raw)) return null;
        const expires = new Date(Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000).toUTCString();
        // Path=/ so it persists across SPA route changes.
        document.cookie = `${COOKIE_NAME}=${raw}; expires=${expires}; path=/; SameSite=Lax`;
        return raw;
    } catch {
        return null;
    }
}

export function getRefCookie() {
    if (typeof document === "undefined") return null;
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    if (!match) return null;
    const v = decodeURIComponent(match[1] || "").trim().toLowerCase();
    return isValid(v) ? v : null;
}

export function clearRefCookie() {
    if (typeof document === "undefined") return;
    document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}
